import { lazy, Suspense } from 'react'
import CurveWalletGate from '@/components/CurveWalletGate'
import type { SimPresale } from '@/lib/presale/types'

const PresalePledgeBoxInner = lazy(() => import('@/components/PresalePledgeBoxInner'))

interface PresalePledgeBoxProps {
  presale: SimPresale
}

function PresalePledgeBox({ presale }: PresalePledgeBoxProps) {
  return (
    <CurveWalletGate actionLabel="Contribute ETH">
      {() => (
        <Suspense fallback={<p className="mt-5 border-t border-white/10 pt-5 text-center text-xs text-zinc-500">Loading pledge panel…</p>}>
          <PresalePledgeBoxInner presale={presale} />
        </Suspense>
      )}
    </CurveWalletGate>
  )
}

export default PresalePledgeBox
